
import { createSlice } from '@reduxjs/toolkit'

 // Define a type for the slice state
export interface ISiteAssistModalState {
    isOpen: boolean
}

 // Define the initial state using that type
const initialState: ISiteAssistModalState = {
    isOpen: false,
}

export const siteAssistModalSlice = createSlice({
    name: 'siteAssistModal',
     // `createSlice` will infer the state type from the `initialState` argument
    initialState,
    reducers: {
        setSiteAssistModalHidden: (state) => {
            state.isOpen = false
        },
        setSiteAssistModalOpen: (state) => {
            state.isOpen = true
        },
    },
})

export const { setSiteAssistModalHidden, setSiteAssistModalOpen } = siteAssistModalSlice.actions

export default siteAssistModalSlice.reducer
